import React from 'react';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import ButtonStyled from './DragButton.styled';

export interface DragButtonProps {
  action?: () => void;
}

const DragButton = ({ action }: DragButtonProps) => {
  return (
    <ButtonStyled
      type="button"
      tabIndex={-1}
      onClick={() => {
        if (action) action();
      }}
      onMouseDown={() => {
        if (action) action();
      }}
    >
      <Icon icon={IconsDictionary.DragIndicator} />
      <span className="sr-only">Drag</span>
    </ButtonStyled>
  );
};

export default DragButton;
